import React from 'react';

const Angebotseite = () => {
  return (
    <div className="app-container">
      <div className="content">
        <h1 className="title">Angebote Schiclub</h1>
        <p className="text">Entdecke unsere Angebote und genieße einen unvergesslichen Tag bei uns. Sowohl für das leibliche Wohl, als auch für den Spaß auf der Piste ist gesorgt!
        <br /> 
        Bitte beachte, dass für die Nutzung des Skilift eine Tagesmitgliedschaft notwendig ist. Diese Regelung basiert auf versicherungsbedingten Gründen und dient der eigenen Sicherheit.</p>
        
        <table>
          <tr>
            <th>Produkt</th>
            <th>Preis</th>
          </tr>
          <tr>
            <td colSpan="2"><strong>Heiße Getränke</strong></td>
          </tr>
          <tr>
            <td>Glühwein</td>
            <td>3,00 €</td>
          </tr>
          <tr>
            <td>Jagertee</td>
            <td>3,00 €</td>
          </tr>
          <tr>
            <td>Früchtepunsch</td>
            <td>2,00 €</td>
          </tr>
          <tr>
            <td>Kaffee</td>
            <td>2,00 €</td>
          </tr>
          <tr>
            <td>Tee</td>
            <td>1,50 €</td>
          </tr>
          <tr>
            <td colSpan="2"><strong>Kalte Getränke</strong></td>
          </tr>
          <tr>
            <td>Wasser</td>
            <td>2,00 €</td>
          </tr>
          <tr>
            <td>Cola, Fanta, Spezi</td>
            <td>3,00 €</td>
          </tr>
          <tr>
            <td>Apfelsaft</td>
            <td>3,00 €</td>
          </tr>
          <tr>
            <td>Bier</td>
            <td>3,00 €</td>
          </tr>
          <tr>
            <td>Schnaps</td>
            <td>2,00 €</td>
          </tr>
          <tr>
            <td colSpan="2"><strong>Speisen</strong></td>
          </tr>
          <tr>
            <td>Heiße Wurst mit Brot</td>
            <td>3,00 €</td>
          </tr>
          <tr>
            <td>Kuchen / Muffin</td>
            <td>1,50 €</td>
          </tr>
        </table>
      </div>
    </div>
  );
};
export default Angebotseite;